import React from 'react';
import { t } from '../../i18n';

// Small speaker pill next to the wordmark (per the mute mock). Mute is per
// phone and saved in localStorage.
export default function SoundToggle({ muted, onToggle }) {
  return (
    <button
      type="button"
      data-testid="sound-toggle"
      onClick={onToggle}
      aria-pressed={muted}
      aria-label={muted ? t('sound.off') : t('sound.on')}
      className="ml-2 w-8 h-8 inline-flex items-center justify-center rounded-full border border-line text-ink bg-transparent active:bg-cream-2"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M11 5 6 9H3v6h3l5 4V5z" />
        {muted ? (
          <>
            <line x1="22" y1="9" x2="16" y2="15" />
            <line x1="16" y1="9" x2="22" y2="15" />
          </>
        ) : (
          <>
            <path d="M15.5 8.5a5 5 0 0 1 0 7" />
            <path d="M18.5 5.5a9 9 0 0 1 0 13" />
          </>
        )}
      </svg>
    </button>
  );
}
